import React, { FC } from 'react'

import { PaymentElement } from '@stripe/react-stripe-js'
import { StripeError, StripePaymentElementOptions } from '@stripe/stripe-js'

// import stripeInputStyles from 'Utils/stripeInputStyles'

import useEvent from 'Hooks/useEvent'

import ErrorMessage from 'Components/ErrorMessage'
import FormErrors from 'Components/FormErrors'

import { usePayment } from '../../Provider'

const StripePaymentFields: FC = () => {
  const { setPaymentStatus, setErrorMessage } = usePayment()

  const options: StripePaymentElementOptions = {
    layout: 'accordion',
    wallets: {
      applePay: 'never',
      googlePay: 'never',
    },
  }

  const handleReady = useEvent(() => setPaymentStatus('ready'))
  const handleError = useEvent(({ error }: { error: StripeError }) => {
    setPaymentStatus('error')
    if (error.message) setErrorMessage(error.message)
  })

  return (
    <>
      <PaymentElement options={options} onLoadError={handleError} onReady={handleReady} />
      <ErrorMessage as={FormErrors} name="stripePayment.sourceId" />
    </>
  )
}

export default StripePaymentFields
